export default __webpack_public_path__ + "static/media/defaultProfile.7ccf36d0.svg";